import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DoneIcon from '@mui/icons-material/Done';
import Flex from '../../../components/base/Flex';
import { useMenu } from '../../../components/base/useMenu';
import CustomButton from '../../../components/customButton';
import { useTheme } from '@emotion/react';
import { useContext } from 'react';
import { ColorContext } from '../../../AppTheme';

const AppFilter = ({ value, setValue, options, title, mobileApps }) => {
  const { triggerProps, menuProps } = useMenu();
  const theme = useTheme();
  const { mode } = useContext(ColorContext)

  const onSelectAll = () => {
    setValue(null);
    menuProps.onClose();
  };

  const onSelectApp = (app) => {
    setValue(app);
    menuProps.onClose();
  };

  return (
    <Box>
      <CustomButton
        disableRipple
        disableFocusRipple
        disableElevation
        {...triggerProps}
        fullWidth
        variant={'outlined'}
        label={
          <Flex>
            <Typography variant={'body2'}>{value?.name || 'Filter by App'}</Typography>
            {menuProps.open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </Flex>
        }
        sx={{
          textAlign: 'center',
          textTransform: 'capitalize',
          borderRadius: '0.4rem',
          color: theme.palette.button.textOutlined,
          border: mode === 'dark' && `1px solid ${theme.palette.button.border}`,
          py: { xs: '0.2rem', sm: '0.3rem' },
          px: 2,
          mr: 1,
          width: 'max-content',
          '&: hover': {
            background: 'transparent'
          }
        }}
      />
      <Menu
        id="action-menu"
        {...menuProps}
        elevation={1}
        PaperProps={{
          style: {
            width: 200,
            paddingLeft: 5,
            paddingRight: 5
          }
        }}>
        <MenuItem onClick={onSelectAll} sx={{ color: value?.name ? 'inherit' : 'blue' }}>
          <Flex>
            <DoneIcon sx={{ visibility: value?.name ? 'hidden' : 'visible' }} />
            All
          </Flex>
        </MenuItem>
        {(mobileApps || []).map((option, index) => (
          <MenuItem
            onClick={() => onSelectApp(option)}
            sx={{ color: option?.name === value?.name ? 'blue' : 'inherit' }}>
            <Flex>
              <DoneIcon sx={{ visibility: option?.name === value?.name ? 'visible' : 'hidden' }} />
              {option?.name}
            </Flex>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default AppFilter;
